"use client";

import LeftArrow from "~/icons/left-arrow.svg";
import Icon1 from "~/icons/menu/I1.svg";
import styles from "./ProgramsMenu.module.scss";
import cn from "clsx";
import { useEffect, useMemo, useState,useRef } from "react";
import Image from "next/image";
import DownLtLogo from "~/icons/down-lt.svg";
import { LinkButton } from "@organisms/Header";
import CrossIcon from "../../../../public/_a/icons/cross.svg";
import { GAEvent, GA_EVENTS, GA_EVENTS_PAYLOAD, IProgramPageSessionData } from "@/helpers/gaEvents";
import { pushToDataLayer } from "@/helpers/gtag";
import { PROGRAMS } from "./constants";
import { usePlatformAndOS } from "@/helpers/usePlatformAndOS";
import { useDeviceInfo } from "@/helpers/userDeviceType";
import { getGAPayload } from "@/helpers/getGAPayload";
import { StorageService } from "@/helpers/storage.service";
import { useQueryParams } from "@/helpers/useQueryParams";
import { getGlobalStateValue } from "@/context/utils";
import VR from "@/SvgIcons/VR";
import BrainStrom from "@/SvgIcons/BrainStrom";
import AI from "@/SvgIcons/AI";
import useOnScreen from "@/helpers/Onscreen";

const Card = ({ item, index, selectedProgram, isMobile=false, selectedCategory="" }: any) => {
  const searchParams = useQueryParams();
  const [pageTitle, setPageTitle] = useState<string>('');
  const [pageReferrer, setPageReferrer] = useState<string>('');
  const { platform = "", os = "", version = "" } = usePlatformAndOS();
  const deviceType = useDeviceInfo();

  const isMbaCard = (item?.Title.toLowerCase().includes("mba") && `/${item?.url}` === PROGRAMS[1].url) || false
  const { PROGRAM_TAB_MBA, NAVIGATION_CLICK } = GAEvent
  let selectedCat = selectedCategory === "INDUSTRY ALIGNED PROGRAM" ? "INDUSTRY-ALIGNED PROGRAMS In collaboration with" : selectedCategory;
  
  useEffect(() => {
    if(isMbaCard){
      setPageReferrer(document.referrer);
      setPageTitle(document.title);
      const handleTitleChange = () => {
        setPageTitle(document.title);
      };
      document.addEventListener('titlechange', handleTitleChange); 
      return () => {
        document.removeEventListener('titlechange', handleTitleChange);
      };
    }
  }, []);

  const handleGaClick = () => {
    if(isMbaCard){
      const gaData = GA_EVENTS_PAYLOAD.get(PROGRAM_TAB_MBA)
      const gaOtherPayloadInfo = {
        platform,
        deviceType,
        version,
        pageTitle,
        pageReferrer,
        pageUrl : typeof window !== 'undefined' ? window.location.href : '',
      }
      const sessionData:IProgramPageSessionData = {
        isNavbarClick : true,
        isMbaPage : true
      }
      StorageService.set("programDetailsGAInfo", sessionData)
      const gaPayload = getGAPayload(gaData,searchParams,gaOtherPayloadInfo);
      pushToDataLayer(gaPayload)
    }else{
      const sessionData:IProgramPageSessionData = {
        isNavbarClick : true,
        isMbaPage : false
      }
      StorageService.set("programDetailsGAInfo", sessionData)
    }
  }

  const handleGaClick2 = (payload={}) => {
    const gaPaylaod = GA_EVENTS.get(NAVIGATION_CLICK);
    pushToDataLayer({...gaPaylaod, ...payload});
  }
  return (
    <div className={cn(styles.tab)}>
      <a
        title={item?.Title}
        href={`/${item?.url}`}
        onClick={()=>{
          handleGaClick();
          handleGaClick2({
            cta_text: item?.Title || "", 
            category : "Programs",
            sub_category : selectedCat || "Program wise",
            section_name : isMobile ? "hamburger" : "header",
            redirection_url : `/${item?.url}`,
            page_type : getGlobalStateValue('pageType') || "Home Page",
            header_title : selectedProgram || "NA"
          });
        }}
      >
        <div className="flex justify-between mb-4">
          <img
            src={item?.IconUrl?.url}
            alt={item?.IconUrl?.alternativeText || ''}
            className={styles.programImage}
            loading="lazy"
          />
        </div>
        <div className={cn("flex justify-between", styles.cardTitle)}>
          <span className="mr-2">{item?.Title}</span>
          <Image src={LeftArrow} alt="Left" />
        </div>
          {item?.year && <span className={styles.year}>{item?.year}</span>}
      </a>
      {
        item.signifiers?.tagName &&
        <span style={{backgroundColor:`${item.signifiers.hexCode}`}} className={styles.tagSignifier}>{item.signifiers.tagName.replace(/_/g, ' ')}</span>
      }
    </div>
  )
};

const DesktopMenuPrograms = ({selectedProgram, PROGRAMS, tabName,label, selectedCategory = ""}: {
  selectedProgram: string;
  PROGRAMS: any;
  tabName: any;
  label: any; 
  selectedCategory : string;
}) => {

  const programsToRender = label === "INDUSTRY_ALIGNED_PROGRAM" || label === "ADD_ON_INDUSTRY_CERTIFICATIONS"
    ? PROGRAMS?.items
    : PROGRAMS; 

    const [visiblePrograms, setVisiblePrograms] = useState(8); 
    const scrollableDiv = useRef<HTMLDivElement | null>(null);

    const onScreen = useOnScreen(scrollableDiv);


    useEffect(()=> {
      if(visiblePrograms <programsToRender.length){
        setVisiblePrograms((visiblePrograms)=>visiblePrograms + 2)
      }
    },[onScreen]);

    
  return (
    <div className="flex flex-col flex-grow"
      style={{display: tabName === selectedProgram ? undefined : 'none'}}
    >
      <div className={styles.selectedProgram}>{selectedProgram}</div>
      <div className={cn("w-full", styles.contentBox)}>
        <div className={cn("flex", styles.tabContainer)}>
          {Array.isArray(programsToRender) && programsToRender.slice(0,visiblePrograms).map((item: any, i: number) => {
            return <Card index={i} key={i} item={item} selectedProgram={selectedProgram} selectedCategory={selectedCategory} />;
          })}
        <div style={{ color: "#fff" }} ref={scrollableDiv}>.</div>
        </div>
      </div>
   </div>
  )
}

 
const MobileMenuPrograms = ({selectedProgram, PROGRAMS, tabName, page,label, selectedCategory = ""}: {
  selectedProgram: string;
  PROGRAMS: any;
  tabName: any;
  page: number;
  label: any; 
  selectedCategory : string;
}) => {
  
  const programsToRender = label === "INDUSTRY_ALIGNED_PROGRAM" || label === "ADD_ON_INDUSTRY_CERTIFICATIONS"
    ? PROGRAMS?.items || [] 
    : PROGRAMS;
    const [visiblePrograms, setVisiblePrograms] = useState(4); 
    const scrollableDiv = useRef<HTMLDivElement | null>(null);

    const onScreen = useOnScreen(scrollableDiv);


    useEffect(()=> {
      if(visiblePrograms <programsToRender.length){
        setVisiblePrograms((visiblePrograms)=>visiblePrograms + 2)
      }
    },[onScreen]);

  return (
    <div className={cn("w-full", styles.contentBox)}
      style={{display: page === 2 && tabName === selectedProgram ? undefined : 'none'}}>
        <div className={cn("flex", styles.tabContainer)}>
          {Array.isArray(programsToRender) &&programsToRender.slice(0,visiblePrograms).map((item: any, i: number) => (
            <Card key={i} index={i} item={item} selectedProgram={selectedProgram} isMobile={true} selectedCategory={selectedCategory} />
            ))}
             <div style={{ color: "#fff" }} ref={scrollableDiv}>.</div>
        </div>
    </div>
  );
}

export default function ProgramMenu({
  isMobile,
  goBack,
  programMenu,
  programDomains,
  closeMenu,
  programMenuOpen
}: {
  isMobile?: boolean;
  goBack?: any;
  programMenu?: any;
  programDomains?: any;
  closeMenu?: any;
  programMenuOpen: boolean
}) {

  const { PROGRAMS, SIDE_MENU_LABELS } = useMemo(() => {
    const PROGRAMS = programMenu["MAIN_LIST"] || [];
    const SIDE_MENU_LABELS = Object.keys(programMenu)
      .splice(1)
      .map((e) => e.split("_").join(" "));

    return {
      PROGRAMS,
      SIDE_MENU_LABELS,
    };
  }, [programMenu]);
  const [{ selectedProgram, content, mobileSectedProgram, selectedCategory }, setMenuItems]: any =
    useState({
      selectedProgram: "All Programs",
      content: PROGRAMS,
      mobileSectedProgram: "",
      selectedCategory : "Program Wise"
    });
   
  const [page, setPage] = useState(1);

  const webengageHandler = (label, tabName) => {

    setTimeout(()=>{
      window.webengage.track("Program Menu Selected",{
        "Category Name": label.replaceAll("_", " "),
        "Sub-Category Name": tabName
      })
    }, 2500)
    
  }
  
  if (isMobile) {
    return (
      <div className={cn(styles.mobile, "program-menu")}
        style={{display: !programMenuOpen ? 'none' : undefined}}
      >
        <div className={cn(styles.nav, "flex items-center")}>
          <Image
            className={styles.submenuArrow}
            src={DownLtLogo}
            alt="Go Back"
            onClick={() => {
              if (page == 2) setPage(1);
              else if (goBack) goBack();
            }}
          />
          {mobileSectedProgram && page == 2 && (
            <span className={styles.mobileSelectedProgram}>
              {mobileSectedProgram}
            </span>
          )}
        </div>
        <div className={cn("flex flex-col min-w-fit", styles.sidemenu)}
          style={{display: page === 1 ? undefined: 'none'}}
        >
            {SIDE_MENU_LABELS.map((label: any, i: number) => {
              const newLabel = label?.split(" ")?.join("_");
              const items = programMenu[newLabel]
                ? Object.keys(programMenu[newLabel])
                : [];

              if (label == "PROGRAM WISE") {
                items.unshift("All Programs");
              }
              return (
                <div className={cn(styles.border)} key={i}>
                {label === "INDUSTRY ALIGNED PROGRAM" ? (
                    <span 
                      title={label}
                      className={cn("font-semibold", styles.label)}
                    >
                      INDUSTRY-ALIGNED PROGRAMS 
                      <br />
                      <span className="capitalize">In</span>
                      <span className="lowercase"> collaboration with</span>
                    </span>
                  ) : label === "ADD ON INDUSTRY CERTIFICATIONS" ? <span 
                        title={label}
                        className={cn("font-semibold", styles.label)}
                        >
                        ADD-ON INDUSTRY CERTIFICATIONS<br/><span className="capitalize">In</span> <span className="lowercase"> collaboration with</span>
                    </span>
                  : (<span
                      title={label}
                      className={cn("font-semibold uppercase", styles.label)}
                    >
                      {label}
                    </span>
                  )}

{!!items?.length && (
  <div>
    {items?.map((item: any, j: number) => {
      const tabName = item?.includes("_")
        ? item?.split("_")?.join(" ")
        : item;

      const Icon = i == 3 ? programDomains?.[item]?.url || Icon1 : null;

      return (
        <div
          onClick={() => {
            pushToDataLayer({
              event: "navigation_click",
              cta_text: tabName || "NA",
              category : "Programs",
              sub_category: label === "INDUSTRY ALIGNED PROGRAM" ? "INDUSTRY-ALIGNED PROGRAMS In collaboration with" : label,
              header_title: tabName || "NA",
              section_name: "hamburger",
              redirection_url: "NA",
              page_type: getGlobalStateValue('pageType'),
            });
            setMenuItems({
              mobileSectedProgram: tabName,
              selectedCategory : label
            });
            setPage(2);
            webengageHandler(newLabel, tabName)
          }}
          key={j}
          className={cn(
            i == 3 && "capitalize",
            "cursor-pointer flex",
            styles.item,
            mobileSectedProgram == tabName && styles.active,
            mobileSectedProgram == tabName && "font-semibold"
          )}
          title={tabName}
        >
          <div className={cn(styles.tagSignifierandNameDiv)}>
          <span className="flex items-center relative">
            {tabName==='Artificial Intelligence' && <AI />}
            {tabName == 'Machine Learning' && <BrainStrom />}
            {tabName =='AR and VR' && <VR />}
            {tabName}
            {(newLabel === "INDUSTRY_ALIGNED_PROGRAM" || newLabel === "ADD_ON_INDUSTRY_CERTIFICATIONS") && programMenu[newLabel][item]?.signifier?.tagName && (
                  <span
                    style={{ backgroundColor: `${programMenu[newLabel][item]?.signifier?.hexCode}` }}
                    className={styles.tagSignifierSidebar}
                  >
                    {programMenu[newLabel][item]?.signifier?.tagName.replace(/_/g, ' ')}
                  </span>
                )}
          </span>
          </div>

          <Image
            className={styles.tabArrow}
            src={DownLtLogo}
            alt="Go Back"
          />
        </div>
      );
    })}
  </div>
                  )}
                </div>
              );
            })}

            <div className="flex">
              <LinkButton
                button={{
                  text: "Explore All Programs",
                  url: "/programs",
                  target: "_self",
                }}
                CN={"w-full"}
              />
            </div>
          </div>

          <MobileMenuPrograms 
            PROGRAMS={PROGRAMS}
            selectedProgram={mobileSectedProgram}
            tabName={"All Programs"}
            label={SIDE_MENU_LABELS}
            page={page}
            selectedCategory={selectedCategory}
          />
          
          {SIDE_MENU_LABELS.map((label: any, i: number) => {
            const newLabel = label?.split(" ")?.join("_");
            const items = programMenu[newLabel]
              ? Object.keys(programMenu[newLabel])
              : [];

              return items?.map((item: any, j: number) => {
                const tabName = item?.includes("_")
                  ? item?.split("_")?.join(" ")
                  : item;
                  const content = programMenu[newLabel][item] || [];
    
                return (
                  <MobileMenuPrograms
                      PROGRAMS={content}
                      tabName={tabName}
                      selectedProgram={mobileSectedProgram}
                      page={page}
                      label={newLabel}
                      key={j}
                      selectedCategory={selectedCategory}
                  />
                );
              })
        })}
      </div>
    );
  }

  return (
    <div className={cn(styles.container, "program-menu rounded-2xl relative")}
       style={{display: !programMenuOpen ? 'none' : undefined}}
    >
      <Image
        alt="close"
        src={CrossIcon}
        className="absolute top-4 right-3 cursor-pointer w-5"
        onClick={closeMenu}
      />
      <div className={cn("flex flex-col min-w-fit", styles.sidemenu)}>
        {SIDE_MENU_LABELS.map((label: any, i: number) => {
          const newLabel = label?.split(" ")?.join("_");
          const items = programMenu[newLabel]
            ? Object.keys(programMenu[newLabel])
            : [];
          if (label == "PROGRAM WISE") {
            items.unshift("All Programs");
          }

          return (
            <div className={cn(styles.border)} key={i}>
              {label==="INDUSTRY ALIGNED PROGRAM" ? 
              <span 
              title={label}
              className={cn("font-semibold", styles.label)}
              >
                INDUSTRY-ALIGNED PROGRAMS<br/><span className="capitalize">In</span> <span className="lowercase"> collaboration with</span>
              </span> : label === "ADD ON INDUSTRY CERTIFICATIONS" ? <span 
              title={label}
              className={cn("font-semibold", styles.label)}
              >
                ADD-ON INDUSTRY CERTIFICATIONS<br/><span className="capitalize">In</span> <span className="lowercase"> collaboration with</span>
              </span> :
              <span
                title={label}
                className={cn("font-semibold uppercase", styles.label)}
              >
                {label}
              </span>
              }
              {!!items?.length && (
                <div>
                  {items?.map((item: any, j: number) => {
                    const tabName = item?.includes("_")
                      ? item?.split("_")?.join(" ")
                      : item;
                    const Icon =
                      i == 3 ? programDomains?.[item]?.url || Icon1 : null;

                    return (
                      <div
                        onClick={() => {
                          pushToDataLayer({
                            event: "navigation_click",
                            cta_text: tabName || "NA",
                            category : "Programs",
                            sub_category: label === "INDUSTRY ALIGNED PROGRAM" ? "INDUSTRY-ALIGNED PROGRAMS In collaboration with" : label,
                            header_title: tabName || "NA",
                            section_name: "header",
                            redirection_url: "NA",
                            page_type: getGlobalStateValue('pageType'),
                          });
                          setMenuItems({
                            selectedProgram: tabName,
                            selectedCategory : label
                          });
                          webengageHandler(newLabel, tabName)
                        }}
                        key={j}
                        className={cn(
                          i == 3 && "capitalize",
                          "cursor-pointer flex items-center gap-5 justify-between",
                          styles.item,
                          selectedProgram == tabName && styles.active,
                          selectedProgram == tabName && "font-semibold"
                        )}
                        title={tabName}
                        
                      >
                        <div
                        className={styles.tagSignifierandNameDiv}
                  >
                         
                        <span className={cn("flex items-center justify-center")}>
                        {tabName==='Artificial Intelligence' &&
            <Image
            width={24}
            height={24}
            src={`https://amityonline.com/_s/artificial_intelligence_21eceded39.svg`}
            alt={item || ''}
            className="mr-1"
          />
            }
            {tabName==='Machine Learning' &&
            <Image
            width={24}
            height={24}
            src={`https://amityonline.com/_s/machine_learning_546b0bf31b.svg`}
            alt={item || ''}
            className="mr-1"
          />
            }
            {tabName==='AR and VR' &&
            <Image
            width={24}
            height={24}
            src={`https://amityonline.com/_s/ar_vr_e8df4f9c4a.svg`}
            alt={item || ''}
            className="mr-1"
          />
            }
                          {tabName}
                        </span>
                
                  {programMenu[newLabel][item]?.signifier?.tagName && (
                    <span
                     style={{ backgroundColor: `${programMenu[newLabel][item]?.signifier?.hexCode}` }}
                      className={styles.tagSignifierSidebar}
                  >
                    {programMenu[newLabel][item]?.signifier?.tagName.replace(/_/g, ' ')}
                  </span>
                )}
                 </div>
                        {selectedProgram == tabName && (
                          <Image
                            className={styles.tabArrow}
                            src={DownLtLogo}
                            alt="Go Back"
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
        <div className="flex">
          <LinkButton
            button={{
              text: "Explore All Programs",
              url: "/programs",
              target: "_self",
            }}
            CN={"w-full"}
          />
        </div>
      </div>
      <DesktopMenuPrograms 
          PROGRAMS={PROGRAMS}
          selectedProgram={selectedProgram}
          tabName={"All Programs"}
          label={SIDE_MENU_LABELS}
          selectedCategory = {selectedCategory}
      />
    
      {SIDE_MENU_LABELS.map((label: any, i: number) => {

          const newLabel = label?.split(" ")?.join("_");
          const items = programMenu[newLabel]
          ? Object.keys(programMenu[newLabel])
          : [];
          
          return items?.map((item: any, j: number) => {
            const tabName = item?.includes("_")
              ? item?.split("_")?.join(" ")
              : item;
              const content = programMenu[newLabel][item] || [];

            return (
              <DesktopMenuPrograms 
                PROGRAMS={content}
                selectedProgram={selectedProgram}
                tabName={tabName}
                key={tabName}
                label={newLabel}
                selectedCategory={selectedCategory}
              />
            );
          })
        })}
    </div>
  );
}
